const Authlayout = ({children}) => {
   return(
     <>
        {children}
     </>
   );         
} 

export default Authlayout;